import React, {Suspense} from 'react';
import {Switch} from 'react-router-dom';
import {LayoutSplashScreen, ContentRoute} from '../../../_metronic/layout';
import {AgentsIncomesPage as AgentsInvoicesPageComponent} from './pages/AgentsIncomesPage';

export default function AgentsIncomesPage() {
  return (
    <Suspense fallback={<LayoutSplashScreen/>}>
      <Switch>
        <ContentRoute path="/agents-incomes" component={AgentsInvoicesPageComponent}/>
      </Switch>
    </Suspense>
  );
}
